export default {
  en : {
    Title : 'Cash flow',
    Region : {
      Title : 'Regions',
      Name : 'Name',
      IncomeTax : 'Income Tax',
      MiningTax : 'Mining Tax',
      AddNew : 'New region',
      Edit : 'Edit region',
      Delete : "Delete region",
      ConfirmDelete : "Do you really want to delete this region?",
      RegionDeleted : "The selected region was successfully deleted",
      AlreadyExists : "A region with the same name already exists"
    },
    Project : {
      Title : 'Projects',
      Name : 'Name',
      RegionName : 'Region',
      AddNew : 'New project',
      Edit : 'Edit project',
      Delete : "Delete project",
      ConfirmDelete : "Do you really want to delete this project?",
      ProjectDeleted : "The selected project was successfully deleted"
    },
    Lom : {
      Name : 'Name',
      Version : 'Version',
      Description : 'Description',
      FileContent : 'File Content',
      YearAdjustment : 'Year Adjustment (+/-)',
      Availability : 'Availability',
      AvailabilityPublic : 'Public',
      AvailabilityPrivate : 'Private',
      UploadTemplateFile : 'Get the upload template file',
      UploadInProgress : 'Upload in progress...',
      UploadInvalidFileError : 'An excel file with .xlsx extension must be provided.',
      ProjectMustBeCreated : 'The model must be created before uploading template',
      UploadCompleted : 'The upload was completed successfully',
      AddNew : 'New model',
      Edit : 'Edit model',
      Delete : "Delete model",
      ConfirmDelete : "Do you really want to delete this model?",
      LomDeleted : "The selected model was successfully deleted",
      UploadFile : "File to upload",
      Tab1 : "General",
      Tab2 : "Upload model File"
    },
    ProjectLom : {
      Title : 'Project Models',
      ExternalProjectName : 'Project',
      HyperionEntityName : 'Hyperion',
      ProjectName : 'Project',
      ProjectSource : 'Project Source'
    },
    CorporateLom : {
      Title : 'Corporate Models'
    },
    LomType : {
      'Name' : "Type",
      '0' : "LOM",
      '1' : "ELOM",
      '2' : "Budget",
      '3' : "Extension",
      '4' : "Evaluation Scenario",
      '5' : "FPM"
    },
    Currency : {
      'Name' : "Currency",
      '0' : "USD",
      '1' : "CAD",
      '2' : "EUR",
      '3' : "MXN",
      '4' : "AUD"
    },
    Compilation : {
      Title : 'Compilations',
      Name : 'Name',
      Description : 'Description',
      Availability : 'Availability',
      AvailabilityPublic : 'Public',
      AvailabilityPrivate : 'Private',
      CreatedBy : 'Created by',
      CreationDate : 'Creation Date',
      ModificationDate: "Modification Date",
      CalculationDate: "Calculation Date",
      MyCompilation : 'Display only my compilations',
      DiscountRate : 'Discount Rate',
      ElementYearlyPriceTemplate : 'Element Price Template',
      YearlyInflationRateTemplate : 'Inflation Rate Template',
      YearlyFxRateTemplate : 'Foreign Exchange Rate Template',
      UserList : 'Users',
      UserEmail : 'User email',
      AddNew : 'New compilation',
      Edit : 'Edit compilation',
      Delete : "Delete compilation",
      ConfirmDelete : "Do you really want to delete this compilation?",
      CompilationDeleted : "The selected compilation was successfully deleted",
      Tab1 : "General Information",
      Tab2 : "Included Models",
      Tab3 : "Compilation Drivers",
      Tab4 : "Security",
      NoDescription : "No description",
      ExternalLOMS : "External Models",
      HyperionLOMS : "Hyperion Models",
      IncludedLOMS : "Included Models",
      IsDecarbonizationScenario : "Decarbonization Scenario",
      ConfirmCalculate : "Do you really want to calculate this compilation?",
      Calculate : "Calculate",
      SaveAndCalculate : "Save and Calculate",
      SendingRequest : "Sending request...",
      RequestSent : "Request Sent",
      Calculation : "Calculation in progress... check the status of the compilation in the Running jobs at the top of the screen.",
      CalculationCompleted : "Calculation completed",
      StartedAt : "Started at",
      CustomizeRatesButton : "Customize rates",
      CancelCustomizedRatesButton : "Cancel customized rates",
      Report : "Report"
    },
    Admin: {
      Title : "Admin"
    },
    Template: {
      Title : "Templates"
    },
    Reports: {
      Title: "Report",
      LOM : "LOM",
      BackToCompilations : "Back to compilations"
    },
    ElementYearlyPriceTemplate:  {
      Title: "Element Yearly Prices templates",
      Name : 'Name',
      ConfirmDelete : "Do you really want to delete this element prices template?",
      DeletedConfirmation : "The selected element prices template was successfully deleted",
      AddNew : 'New template',
      Edit : "Edit template",
      Tab1Title: "Template",
      Tab2Title: "Prices per year/element",
      Tab2Unavailable: "Prices per year/element is not available until the template is saved"
    },
    ElementYearlyPrice:  {
      Title: "Metal yearly price",
      Price : 'Price',
      Year : 'Year',
      StartYear : 'Start year',
      EndYear : 'End year',
      Element : 'Element',
      Total : "Total",
      ConfirmDelete : "Do you really want to delete this element?",
      DeletedConfirmation : "The selected element was successfully deleted",
      BatchAddTitle: "Add element prices",
      AddNew : 'New price',
      Edit : "Edit price"
    },
    YearlyFxRateTemplate:  {
      Title: "Yearly FX Rate templates",
      Name : 'Name',
      ConfirmDelete : "Do you really want to delete this FX rate template?",
      DeletedConfirmation : "The selected FX rate template was successfully deleted",
      AddNew : 'New template',
      Edit : "Edit template",
      Tab1Title: "Template",
      Tab2Title: "Rates per year/currency",
      Tab2Unavailable: "Rates per year/currency is not available until the template is saved"
    },
    YearlyFxRate:  {
      Title: "Yearly FX rate",
      Rate : 'Rate',
      OriginalRate : 'Template rate: ',
      Year : 'Year',
      StartYear : 'Start year',
      EndYear : 'End year',
      Currency : 'Currency',
      ConfirmDelete : "Do you really want to delete this rate?",
      DeletedConfirmation : "The selected rate was successfully deleted",
      BatchAddTitle: "Add currency rates",
      AddNew : 'New rate',
      Edit : "Edit rate"
    },
    YearlyInflationRateTemplate:  {
      Title: "Yearly Inflation Rate templates",
      Name : 'Name',
      ConfirmDelete : "Do you really want to delete this inflation rate template?",
      DeletedConfirmation : "The selected inflation rate template was successfully deleted",
      AddNew : 'New template',
      Edit : "Edit template",
      Tab1Title: "Template",
      Tab2Title: "Rates per year/category",
      Tab2Unavailable: "Rates per year/category is not available until the template is saved"
    },
    YearlyInflationRate:  {
      Title: "Yearly Inflation rate",
      Rate : 'Rate',
      OriginalRate : 'Template rate: ',
      Year : 'Year',
      StartYear : 'Start year',
      EndYear : 'End year',
      Category : 'Category',
      ConfirmDelete : "Do you really want to delete this rate?",
      DeletedConfirmation : "The selected rate was successfully deleted",
      BatchAddTitle: "Add category rates",
      AddNew : 'New rate',
      Edit : "Edit rate"
    },
    InflationCategory : {
      'Name' : "Inflation Category",
      '0' : "Open Pit Costs",
      '1' : "Underground Costs",
      '2' : "Heap Leach Costs",
      '3' : "Mill Costs",
      '4' : "Site Costs",
      '5' : "Sustaining Capital",
      '6' : "Growth Capital"
    }
  }
}
